
import { Injectable } from '@angular/core';
import { TelemetryService } from './telemetry/telemetry.service';
import { LoggingService } from './logging/logging.service';

@Injectable({
  providedIn: 'root',
})
export class MobilePerformanceService {
  private milestones: { [key: string]: number } = {};
  private webVitals: { [key: string]: number } = {};
  private isMobileDevice: boolean;

  constructor(
    private telemetry: TelemetryService,
    private logger: LoggingService
  ) {
    this.isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    console.log('[MobilePerformanceService] Initialized with service name:', telemetry.getServiceName());
  }

  trackMilestone(name: string, timestamp: number = performance.now()): void {
    this.milestones[name] = timestamp;
    this.telemetry.trackEvent(`milestone.${name}`, { 
      timestamp,
      isMobileDevice: this.isMobileDevice
    });
    this.logger.debug('MobilePerformanceService', `Tracked milestone: ${name}`, { timestamp });
  }

  getMilestone(name: string): number | undefined {
    return this.milestones[name];
  }

  trackWebVital(name: string, value: number): void {
    this.webVitals[name] = value;
    this.telemetry.trackEvent(`webvital.${name}`, { 
      value,
      isMobileDevice: this.isMobileDevice
    });
    this.logger.debug('MobilePerformanceService', `Tracked web vital: ${name}`, { value });
  }

  getWebVital(name: string): number | undefined {
    return this.webVitals[name];
  }

  trackNetworkError(name: string, error: any): void {
    this.telemetry.trackError(`network.${name}`, {
      error: error?.message || String(error),
      isMobileDevice: this.isMobileDevice
    });
  }

  trackAppBootstrapComplete(): void {
    this.trackMilestone('app_bootstrap_complete');
    this.logger.info('MobilePerformanceService', 'Application bootstrap completed');
  }

  trackNetworkRequest(method: string, url: string): { spanId: string, headers: Record<string, string> } {
    this.telemetry.trackEvent('network.request', { method, url, isMobileDevice: this.isMobileDevice });
    return { spanId: `${method}-${url}-${Date.now()}`, headers: {} };
  }

  endNetworkRequestTrace(spanId: string, status: number, responseTime: number): void {
    this.telemetry.trackEvent('network.response', {
      spanId,
      status,
      responseTime,
      isMobileDevice: this.isMobileDevice
    });
  }

  calculateBootstrapDuration(): number | null {
    const bootstrapStart = this.getMilestone('app_start');
    const bootstrapComplete = this.getMilestone('app_bootstrap_complete');
    if (bootstrapStart && bootstrapComplete) {
      return bootstrapComplete - bootstrapStart;
    }
    return null;
  }
}